var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-around p-2 max-w-full"},_vm._l((_vm.logos),function(logo){return _c('img',{key:logo.src,attrs:{"src":logo.url,"title":logo.title,"alt":logo.title}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }